import React, { Component } from 'react'
import { withTheme } from 'styled-components';

import { Flex, FlexColumn } from '../../../../Reusable/Container';
import { Tag, Text } from '../../../../Reusable/Text';
import hexToRgba from 'hex-to-rgba';
import BillTable from '../../../Bills/BillTable';
import { getLogoFromDomain, toCurrency, toAbsCurrency, capitalizeFirstLetter } from '../../../../../Utils/util';
import { apiPOSTReq } from '../../../../../Utils/api';
import environment from '../../../../../environment';
import { InitialCircle } from '../../../../Reusable/InitialCircle';

import { CardContainer } from './CardContainer';
import VendorCard from './VendorCard';
import { ErrorAlert } from '../../../../Reusable/Alert';
import { isEmpty } from 'underscore';
import TableView from '../../../../Reusable/TableView';
import { Button } from '../../../../Reusable/Button';
import { LabeledInput } from '../../../../Reusable/Input';
import { Image } from '../../../../Reusable/Image';
import Search from '../../../../../Images/search.png'

class ChangeVendor extends Component {
    state = {
        bill: this.props.bill,
        vendor: this.props.vendor,
        loading: false,
        pagination: {
            current: 1,
            pageSize: 50,
        },
        searchPagination: {
            current: 1,
            pageSize: 50,
        }
    }

    componentDidMount() {
        this.fetchData({ pagination: this.state.pagination });
    }

    fetchData(options) {
        const { pagination, sortDirection, sortFieldName } = options;

        var body = {
            "size": pagination.pageSize,
            "page": pagination.current - 1,
            "viewBy": "FILTER_ACTIVE",
            "sortFieldName": "VendorName",
            "sortDirection": "ASC"
        }

        if(sortFieldName) {
            body.sortFieldName = sortFieldName;
            body.sortDirection = sortDirection || "DESC";
        }

        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getVendors`, {}, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp
                if (data.result) {
                    this.setState({
                        ...data,
                        pagination: {
                            ...pagination,
                            total: data.count
                        },
                        sortFieldName: body.sortFieldName,
                        sortDirection: body.sortDirection
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getActiveCustomers", error, err, resp)
                this.setState({ loading: false })
                ErrorAlert({ description: error.message })
            }
        })
    }

    selectRow = (selectedVendor) => {
        this.props.updateBillVendor({ vendor: selectedVendor, loadStep: "Edit" });
    }

    handleTableChange = (pagination, filters, sorter) => {
        sorter = sorter || {};
        var sortFieldName = null;
        var sortDirection = null;

        if(sorter.order) {
            if(sorter.order == 'ascend') sortDirection = 'ASC';
            else sortDirection = 'DESC';
        }
        
        if(sorter.field) {
            sortFieldName = capitalizeFirstLetter(sorter.field);
        }

        if(!isEmpty(this.state.vendorSearch)) {
            this.onSearch({ vendorSearch: this.state.vendorSearch, pagination, sortDirection, sortFieldName });
        } else {
            this.fetchData({ pagination, sortDirection, sortFieldName });
        }   
    }

    onSearch = ({ vendorSearch, pagination, sortFieldName, sortDirection }) => {
        if (!vendorSearch) {
            return this.fetchData({ pagination: this.state.pagination, sortFieldName: this.state.sortFieldName, sortDirection: this.state.sortDirection })
        }
        let searchPagination = pagination || this.state.searchPagination
        const body = {
            "size": searchPagination.pageSize,
            "page": searchPagination.current - 1,
            "viewBy": "FILTER_BY_ACTIVE",
            sortFieldName: sortFieldName || this.state.sortFieldName, 
            sortDirection: sortDirection || this.state.sortDirection
        }

        if (vendorSearch && vendorSearch.includes("@")) {
            body.searchEmail = vendorSearch
        } else {
            body.searchStr = vendorSearch
        }

        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/lookupVendors`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp
                console.log("/lookupVendors", data)
                if (data.result) {
                    this.setState({
                        ...data,
                        pagination: {
                            ...searchPagination,
                            total: data.count
                        },
                        sortFieldName: body.sortFieldName, 
                        sortDirection: body.sortDirection
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getContractors", error, err, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    onSearchChange = (e) => {
        this.setState({ vendorSearch: e.target.value })
        this.setState({
            pagination: {
                current: 1,
                pageSize: 50
            }
        })
        this.onSearch({ vendorSearch: e.target.value });
    }

    handleNewVendor = () => {
        this.props.loadStep("NewVendor");
    }

    render() {
        var { theme, bill } = this.props;
        var { vendor, pagination, vendors, tab, inactiveVendors, paymentMethodRecipientMap, showDeactivate, deactivateLoading, vendorToDelete, sortFieldName, sortDirection } = this.state;
        bill = bill || {};
        vendor = vendor || {};
        
        return (
            <>
                <FlexColumn style={{ marginTop: '24px' }}>

                    <TableView
                        id="vendor-table"
                        titleText={`Select a vendor`}
                        descText={`This will update the vendor for bill #${bill.invoiceNumber}`}
                        tableLayout='auto'
                        columns={[{
                            title: 'Name',
                            dataIndex: 'vendorName',
                            key: 'vendorName',
                            sorter: true,
                            render: (item, record) => (
                                <Flex start centerHorizontally gap='8px'>
                                    <div>
                                        <InitialCircle size={30} name={item} useFirstWordOnly={true} logoUrl={getLogoFromDomain(record.primaryEmail)} />
                                    </div>
                                    
                                    <FlexColumn start gap='2px'>
                                        <Flex start centerH gap='8px'>
                                            <Text weight={500} color={theme.colors.primary2}>{item}</Text>
                                            {record.openInboxItemsCount > 0 && <Tag primary>{record.openInboxItemsCount} New | ${toCurrency(record.totalOpenInboxAmount)} total</Tag>}
                                        </Flex>
                                        
                                        <Flex start gap='4px'>
                                            <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>Balance: ${toCurrency(record.outstandingBalance)}</Text>
                                            {record.overdueBillsCount > 0 && <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>| {record.overdueBillsCount} bills overdue</Text>}
                                        </Flex>
                                        
                                    </FlexColumn>
                                </Flex>
                            )
                        }]}
                        dataSource={vendors}
                        rowKey='id'
                        pagination={pagination}
                        loading={this.state.loading}
                        // scroll={{ y: '700px', x: '100%' }}
                        sortFieldName={sortFieldName}
                        sortDirection={sortDirection}
                        onRow={(record) => ({
                            onClick: () => {
                                this.selectRow(record)
                            }
                        })}
                        style={{ flex: 1 }}
                        onChange={this.handleTableChange}
                        ctaContent={
                            <Button solid permtype="Payables.Vendors" onClick={this.handleNewVendor} text='CREATE NEW' />
                        }
                        ctaSecondary={
                            <LabeledInput
                                id="searchTerm"
                                key="searchTerm"
                                placeholder="Search vendors"
                                prefixIcon={<Image width='12px' height='12px' src={Search} />}
                                onChange={this.onSearchChange}
                                width='250px'
                                nomargin
                            />
                        }
                        borderView
                    />
                </FlexColumn>
            </>            
        )
    }
}

export default withTheme(ChangeVendor)